(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["burj-client-portal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-bq-portal]';

    function getFocusable(container) {
      return [...container.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )].filter((element) => !element.hasAttribute('hidden') && element.offsetParent !== null);
    }

    function copyText(text) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
      }

      return new Promise((resolve, reject) => {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();

        try {
          const successful = document.execCommand('copy');
          textarea.remove();
          successful ? resolve() : reject(new Error('Copy command failed'));
        } catch (error) {
          textarea.remove();
          reject(error);
        }
      });
    }

    function initPortal(root) {
      if (!root || root.dataset.bqInitialized === 'true') return;
      root.dataset.bqInitialized = 'true';

      const toggle = root.querySelector('[data-bq-toggle-banks]');
      const bankShell = root.querySelector('[data-bq-bank-shell]');
      const modal = root.querySelector('[data-bq-modal]');
      const modalBody = root.querySelector('[data-bq-modal-body]');
      const toast = root.querySelector('[data-bq-toast]');
      let lastFocused = null;
      let toastTimer = null;
      let closeTimer = null;

      const showToast = (message) => {
        if (!toast) return;
        window.clearTimeout(toastTimer);
        toast.textContent = message;
        toast.classList.add('is-visible');
        toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 2300);
      };

      const setBanksOpen = (open) => {
        if (!toggle || !bankShell) return;
        toggle.setAttribute('aria-expanded', String(open));
        bankShell.classList.toggle('is-open', open);
        bankShell.setAttribute('aria-hidden', String(!open));

        if (open) {
          bankShell.removeAttribute('inert');
          window.setTimeout(() => {
            bankShell.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 180);
        } else {
          bankShell.setAttribute('inert', '');
        }
      };

      const closeModal = () => {
        if (!modal || modal.hidden) return;
        modal.classList.remove('is-open');
        document.documentElement.classList.remove('bq-scroll-lock');
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          modal.hidden = true;
          if (modalBody) modalBody.innerHTML = '';
          if (lastFocused && document.contains(lastFocused)) lastFocused.focus();
        }, 320);
      };

      const openModal = (templateId, trigger) => {
        const template = document.getElementById(templateId);
        if (!template || !modal || !modalBody) return;

        lastFocused = trigger;
        modalBody.innerHTML = '';
        modalBody.appendChild(template.content.cloneNode(true));
        modal.hidden = false;
        document.documentElement.classList.add('bq-scroll-lock');

        requestAnimationFrame(() => {
          modal.classList.add('is-open');
          const focusables = getFocusable(modal);
          (focusables[0] || modal).focus?.();
        });
      };

      toggle?.addEventListener('click', () => {
        const shouldOpen = toggle.getAttribute('aria-expanded') !== 'true';
        setBanksOpen(shouldOpen);
      });

      root.addEventListener('click', (event) => {
        const bankButton = event.target.closest('[data-bq-open-bank]');
        if (bankButton && root.contains(bankButton)) {
          openModal(bankButton.dataset.templateId, bankButton);
          return;
        }

        if (event.target.closest('[data-bq-close-modal]')) {
          closeModal();
          return;
        }

        const copyButton = event.target.closest('[data-bq-copy]');
        if (copyButton && modal?.contains(copyButton)) {
          const detail = copyButton.closest('[data-bq-bank-detail]');
          const lines = [];

          detail?.querySelectorAll('[data-bq-copy-fields] > div').forEach((row) => {
            const label = row.querySelector('dt')?.textContent?.trim();
            const value = row.querySelector('dd')?.textContent?.trim();
            if (label && value) lines.push(`${label}: ${value}`);
          });

          const text = lines.join('\n');
          if (lines.length < 2) {
            showToast('Add the bank payment fields in the theme editor first.');
            return;
          }

          copyText(text)
            .then(() => {
              const label = copyButton.querySelector('span');
              const original = label?.textContent;
              if (label) label.textContent = 'Copied';
              showToast('Bank details copied to clipboard.');
              window.setTimeout(() => {
                if (label) label.textContent = original || 'Copy bank details';
              }, 1800);
            })
            .catch(() => showToast('Copy failed. Please select and copy the details manually.'));
          return;
        }

        const appButton = event.target.closest('[data-bq-open-app]');
        if (appButton && modal?.contains(appButton)) {
          const ua = navigator.userAgent || '';
          const isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
          const isAndroid = /Android/i.test(ua);
          const deepLink = appButton.dataset.appLink || '';
          const iosUrl = appButton.dataset.iosUrl || '';
          const androidUrl = appButton.dataset.androidUrl || '';
          const webUrl = appButton.dataset.webUrl || '';
          const fallback = isIOS ? iosUrl : isAndroid ? androidUrl : webUrl;

          if (!isIOS && !isAndroid) {
            if (webUrl) window.open(webUrl, '_blank', 'noopener,noreferrer');
            else if (fallback) window.location.href = fallback;
            else showToast('No desktop banking link has been added yet.');
            return;
          }

          if (!deepLink) {
            if (fallback) window.location.href = fallback;
            else showToast('Add the app or store link in the theme editor.');
            return;
          }

          let appOpened = false;
          const onVisibilityChange = () => {
            if (document.visibilityState === 'hidden') appOpened = true;
          };

          document.addEventListener('visibilitychange', onVisibilityChange, { once: true });
          window.location.href = deepLink;

          window.setTimeout(() => {
            if (!appOpened && document.visibilityState === 'visible' && fallback) {
              window.location.href = fallback;
            }
          }, 1400);
        }
      });

      modal?.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeModal();
          return;
        }

        if (event.key !== 'Tab') return;
        const focusables = getFocusable(modal);
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      document.addEventListener('shopify:block:select', (event) => {
        if (!root.contains(event.target)) return;
        setBanksOpen(true);
        const selectedBank = event.target.closest('[data-bq-open-bank]');
        if (selectedBank) selectedBank.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    function initAll(scope = document) {
      if (scope.matches?.(SELECTOR)) initPortal(scope);
      scope.querySelectorAll?.(SELECTOR).forEach(initPortal);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
